import * as types from '../actionType';

let initState = [];

function jobTypeState(state = initState, action) {
  switch (action.type) {
      case types.JOBTYPE_LIST_SUCCESS: {
        return action.result;
      }
      default:
        return state;
  }
}


export default jobTypeState;